import React from 'react'
import styled from 'styled-components'
import moment from 'moment'

import { Input } from '../../input'
import { FONTS } from '../../../constants'

export const ProjectInfo = (props) => {
  const {
    data: { project_code },
    projectNonService: {
      _project_manager_names = [],
      _project_approver_names = [],
      _key_project_manager_name,
      project_type,
      _client_name,
      name,
      _project_supervisor_name,
      _company_name,
      _lob_name,
      _department_name,
      start_date,
      end_date,
      description,
    },
    handleInput,
  } = props

  return (
    <Root>
      <Row>
        <LabelCol>
          <Title>Project Manager</Title>
        </LabelCol>
        <DetailCol>
          {_project_manager_names.map((pm, key) => <Text key={ key }>{ pm }</Text>)}
        </DetailCol>
      </Row>
      <Row>
        <LabelCol>
          <Title>Additional Approver</Title>
        </LabelCol>
        <DetailCol>
          {_project_approver_names.map((pa, key) => <Text key={ key }>{ pa }</Text>)}
        </DetailCol>
      </Row>
      <Row>
        <LabelCol>
          <Title>Key PM</Title>
        </LabelCol>
        <DetailCol>
          <Text>{ _key_project_manager_name || '-' }</Text>
        </DetailCol>
      </Row>
      <Row>
        <LabelCol>
          <Title>Project Type</Title>
        </LabelCol>
        <DetailCol>
          <Text>{ project_type || '-' }</Text>
        </DetailCol>
      </Row>
      <Row>
        <LabelCol>
          <Title>Client</Title>
        </LabelCol>
        <DetailCol>
          <Text>{ _client_name || '-' }</Text>
        </DetailCol>
      </Row>
      <Row>
        <LabelCol>
          <Title>Project Code</Title>
        </LabelCol>
        <DetailCol>
          <Input
            name='project_code'
            placeholder='Enter project code here'
            value={ project_code }
            onChange={ e => handleInput(e.target.value, 'project_code') }
          />
        </DetailCol>
      </Row>
      <Row>
        <LabelCol>
          <Title>Project Name</Title>
        </LabelCol>
        <DetailCol>
          <Text>{ name || '-' }</Text>
        </DetailCol>
      </Row>
      <Row>
        <LabelCol>
          <Title>PM Supervisor</Title>
        </LabelCol>
        <DetailCol>
          <Text>{ _project_supervisor_name || '-' }</Text>
        </DetailCol>
      </Row>
      <Row>
        <LabelCol>
          <Title>Company</Title>
        </LabelCol>
        <DetailCol>
          <Text>{ _company_name || '-' }</Text>
        </DetailCol>
      </Row>
      <Row>
        <LabelCol>
          <Title>LOB</Title>
        </LabelCol>
        <DetailCol>
          <Text>{ _lob_name || '-' }</Text>
        </DetailCol>
      </Row>
      <Row>
        <LabelCol>
          <Title>Department</Title>
        </LabelCol>
        <DetailCol>
          <Text>{ _department_name || '-' }</Text>
        </DetailCol>
      </Row>
      <Row>
        <LabelCol>
          <Title>Period</Title>
        </LabelCol>
        <DetailCol>
          <DateRow>
            <Col style={ { marginRight: 40 } }>
              <Text>Starts on</Text>
              <Text>{ start_date ? moment(start_date).format('DD/MM/YYYY') : '-' }</Text>
            </Col>
            <Col>
              <Text>Ends on</Text>
              <Text>{ end_date ? moment(end_date).format('DD/MM/YYYY') : '-' }</Text>
            </Col>
          </DateRow>
        </DetailCol>
      </Row>
      <Row>
        <LabelCol>
          <Title>Description</Title>
        </LabelCol>
        <DetailCol>
          <Text>{ description || '-' }</Text>
        </DetailCol>
      </Row>
    </Root>
  )
}

const Root = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 0 16px;
`

const Row = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  margin-bottom: 16px;
`

const DateRow = styled.div`
  display: flex;
  align-items: center;
`

const Col = styled.div`
  display: flex;
  flex-direction: column;
`

const LabelCol = styled.div`
  height: 100%;
  display: flex;
  flex: 1;
`

const DetailCol = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  flex: 2;
`

const Title = styled.span`
  font-family: ${FONTS.GOTHAM_BOLD};
  font-size: ${FONTS.NORMAL_SIZE};
  color: #1A1A17;
`

const Text = styled.span`
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.SMALL_SIZE};
  color: #1A1A17;
`



// WEBPACK FOOTER //
// ./src/components/project-code/project-detail/project-info.js